import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/layout/Navbar/Navbar';
import { Footer } from './components/layout/Footer/Footer';
import { LiquidCursor } from './components/ui/LiquidCursor/LiquidCursor';
import { ScrollIndicator } from './components/ui/ScrollIndicator/ScrollIndicator';
import { Preloader } from './components/ui/Preloader/Preloader';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Admin } from './pages/Admin';
import { BookTickets } from './pages/BookTickets';
import { OrderSummary } from './pages/OrderSummary';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { PaymentFailed } from './pages/PaymentFailed';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsConditions } from './pages/TermsConditions';
import { RefundPolicy } from './pages/RefundPolicy';
import { ContactUs } from './pages/ContactUs';
import { AboutUs } from './pages/AboutUs';
import './styles/global.css';

// Helper component to manage smooth scroll behavior for active hash fragments on load and page changes.
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Slight delay to ensure the page components have fully rendered
        const t = setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 120);
        return () => clearTimeout(t);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading) {
      const t = setTimeout(() => {
        setLoading(false);
      }, 1300);
      return () => clearTimeout(t);
    }
  }, [loading]);

  return (
    <Router>
      <ScrollToHash />
      <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
      <LiquidCursor />
      <ScrollIndicator />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/book-tickets" element={<BookTickets />} />
          <Route path="/order-summary" element={<OrderSummary />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
